// 自定义事件组件
export default function Event () {    
    this._listeners = {},
    this.on = function(type, fn) {
        if (typeof this._listeners[type] === "undefined") {
            this._listeners[type] = [];
        }
        if (typeof fn === "function") {
            this._listeners[type].push(fn);
        }    
        return this;
    },
    this.emit = function(type) {
        var arrayEvent = this._listeners[type];
        if (arrayEvent instanceof Array) {
            for (var i = 0, length = arrayEvent.length; i < length; i += 1) {
                if (typeof arrayEvent[i] === "function") {
                    if(type==='timeupdate'||type==='loadedmetadata'){
                        Array.prototype.splice.call(arguments, 0, 1, {type: type,ag:arguments.length>1?arguments[1]:''})
                    }else{
                        Array.prototype.splice.call(arguments, 0, 1, {type: type})
                    }
                    arrayEvent[i].apply(null, arguments)
                }
            }
        }
        return this;
    },
    this.off = function(type, fn) {
        var arrayEvent = this._listeners[type];
        if (typeof type === "string" && arrayEvent instanceof Array) {
            if (typeof fn === "function") {
                for (var i = 0, length = arrayEvent.length; i < length; i += 1){
                    if (arrayEvent[i] === fn){
                        this._listeners[type].splice(i, 1);
                        break;
                    }
                }
            } else {
                delete this._listeners[type];
            }
        }
        return this;
    }
}